import { useEffect, useState } from 'react'
import { Button, Card, DataTable } from '@w7/ui'
import { bookmakerApi, bmErrorMessage, unwrapBmList } from '@/api/bookmaker'
import { BmPage } from './BmPage'

export function BothRatesPage() {
  const [rows, setRows] = useState<Record<string, unknown>[]>([])
  const [backButtonNo, setBackButtonNo] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [msg, setMsg] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function load() {
    setBusy(true)
    setError(null)
    try {
      const data = await bookmakerApi.bothRatesGetAll()
      setRows(unwrapBmList(data))
    } catch (e) {
      setError(bmErrorMessage(e))
    } finally {
      setBusy(false)
    }
  }

  useEffect(() => {
    void load()
  }, [])

  async function onAdd() {
    const n = Number(backButtonNo)
    if (!Number.isFinite(n) || n < 0 || n > 999) {
      setError('Enter valid rate between 0 to 999')
      return
    }
    setBusy(true)
    setError(null)
    setMsg(null)
    try {
      await bookmakerApi.bothRatesSave({ backButtonNo: n })
      setBackButtonNo('')
      setMsg('Both rate saved successfully')
      await load()
    } catch (e) {
      setError(bmErrorMessage(e))
    } finally {
      setBusy(false)
    }
  }

  async function onDelete(row: Record<string, unknown>) {
    const id = String(row._id ?? row.id ?? '')
    if (!id) return
    setBusy(true)
    setError(null)
    setMsg(null)
    try {
      await bookmakerApi.bothRatesDelete({ _id: id })
      setMsg('Deleted successfully')
      await load()
    } catch (e) {
      setError(bmErrorMessage(e))
    } finally {
      setBusy(false)
    }
  }

  return (
    <BmPage
      title="Both Rates"
      description="Preset Both Back buttons for Markets View (stored in bookmaker.both_rates)"
      error={error}
      actions={
        <>
          <Button onClick={() => void load()} disabled={busy}>
            Refresh
          </Button>
        </>
      }
    >
      {msg ? <p style={{ margin: 0, opacity: 0.8 }}>{msg}</p> : null}
      <Card>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'end', marginBottom: 16 }}>
          <label style={{ display: 'grid', gap: 4 }}>
            <span style={{ fontSize: 13, opacity: 0.8 }}>Back Button No (0–999)</span>
            <input
              type="number"
              min={0}
              max={999}
              step="1"
              value={backButtonNo}
              disabled={busy}
              onChange={(e) => setBackButtonNo(e.target.value)}
              style={{ padding: '6px 10px', minWidth: 140 }}
            />
          </label>
          <Button disabled={busy} onClick={() => void onAdd()}>
            Add
          </Button>
        </div>
        <DataTable
          label="Both Rates"
          columns={[
            {
              id: 'backButtonNo',
              header: 'Back Button No',
              cell: (r: Record<string, unknown>) =>
                String(r.backButtonNo ?? r.back ?? r.runNo ?? '—'),
            },
            {
              id: 'actions',
              header: '',
              cell: (r: Record<string, unknown>) => (
                <Button disabled={busy} onClick={() => void onDelete(r)}>
                  Delete
                </Button>
              ),
            },
          ]}
          rows={rows}
          loading={busy}
          rowKey={(r) => String(r._id ?? r.id ?? r.backButtonNo ?? Math.random())}
        />
      </Card>
    </BmPage>
  )
}
